'use strict';

define('open-login-modal',['jquery'], function ($) {

  var $loginButton,
      $loginModalPortal,
      $loginModalSystem,
      $loginButtonOpenPortalModal,
      $loginButtonOpenSystemModal,
      $loginButtonClosePortalModal,
      $loginButtonCloseSystemModal;

  var
    local_opts = {
      animation_duration: 250
    };


  var openModelPortal = function() {
    $loginModalPortal.foundation('reveal','open', {
      animation_speed: local_opts.animation_duration
    });
  };

  var openModelSystem = function() {
    $loginModalSystem.foundation('reveal','open', {
      animation_speed: local_opts.animation_duration
    });
  };

  var closeModelPortal = function() {
    $loginModalPortal.foundation('reveal','close', {
      animation_speed: local_opts.animation_duration
    });
  };

  var closeModelSystem = function() {
    $loginModalSystem.foundation('reveal','close', {
      animation_speed: local_opts.animation_duration
    });
  };


  var attachEvents = function() {
    $loginButtonOpenPortalModal.click(openModelPortal);
    $loginButtonOpenSystemModal.click(openModelSystem);
    $loginButtonClosePortalModal.click(closeModelPortal);
    $loginButtonCloseSystemModal.click(closeModelSystem);
    $loginButton.click(closeModelPortal);
    $loginButton.click(closeModelSystem);
  };

  var initialize = function() {

    $loginButton                  = $('.js-login-button'),
    $loginModalPortal             = $('#loginModalPortal'),
    $loginModalSystem             = $('#loginModalSystem'),
    $loginButtonOpenPortalModal   = $('.js-login-open-portal-modal'),
    $loginButtonOpenSystemModal   = $('.js-login-open-system-modal'),
    $loginButtonClosePortalModal  = $('.js-login-close-portal-modal'),
    $loginButtonCloseSystemModal  = $('.js-login-close-system-modal');

    attachEvents();
  };

  return {
    init: initialize
  };
});
